module.exports = __webpack_public_path__ + "static/img/preview-orange-no-progress-bar.da67dffc.png";